import { RootState } from '../../../state/state';

export const fareRulesFeatureKey = 'fare-rules';

export interface State extends RootState {
  fareRulesState: FareRulesState;
}

export interface FareRulesState {
  fareBasisCodes?: string[];
  classOfServiceOrBookingCodes?: string[];
  operationalCarrierCodes?: string[];
  endorsements?: string[];
}

export const initialFareRulesState: FareRulesState = {
  fareBasisCodes: null,
  classOfServiceOrBookingCodes: null,
  operationalCarrierCodes: null,
  endorsements: null,
};
